import axios from "./httpClient";

import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { IUploadFile } from "../models/master";
import { throwApiError } from "./apiError";


/**
 * Upload Image API call using Axios
 * @returns - Upload Investigation Image api and return same success message
 */

export const FileUploadAPI = async (files: File[] , params: IUploadFile, partialHeaders: Record<string, string>) => {
  try {
    const formData = new FormData();
    files.forEach(file => {
      formData.append('files', file);
    });
    if (params.proNumber) {
      formData.append('proNumber', params.proNumber.toString());
    }
    const headers = {
      "OSD-Module-Name": "fileUpload",
      "OSD-Section-Name": "uploadDocument",
      "OSD-Action-Type": "upload",
      "OSD-Exception-Number": params.osdNumber?.toString(),
      ...partialHeaders,
    };
    const response = await axios.post(`${getUrl(ApiType.UPLOAD_FILE)}/${params.osdNumber}/${params.docType}/${params.uploadKey}`, formData, { headers });
    return response.data;
  } catch (error: any) {
    return throwApiError(error, ErrorMessages.investigationImageUploadAPIError);
  }
};
